import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('dronesToolbar');

    return {
        ALL: t('all'),
        GROUNDED: t('grounded')
    };
};

export default useTranslation;
